import I18n from 'I18n';
import { useMemo } from 'react';
import { useQuery } from 'data-fetching-client';
import { FETCH_HAS_DISMISSED_YEAR_IN_REVIEW_REQUEST } from '../queries/useHasDismissedYearInReview';
import { FETCH_PORTAL_ROLL_UP_LIMIT } from '../queries/export';
import useUserInfo from 'messaging-management-lib/user/hooks/useUserInfo';
const MILLISECONDS_IN_A_YEAR = 31536000000;
export default function useHasYearInReviewBanner() {
  const {
    userInfo
  } = useUserInfo();
  const userSettings = useQuery(FETCH_HAS_DISMISSED_YEAR_IN_REVIEW_REQUEST);
  const rollupLimitData = useQuery(FETCH_PORTAL_ROLL_UP_LIMIT);
  const hasDismissedYearInReview = useMemo(() => {
    var _userSettings$data;
    const dismissedYearInReview = userSettings === null || userSettings === void 0 || (_userSettings$data = userSettings.data) === null || _userSettings$data === void 0 ? void 0 : _userSettings$data.dismissedYearInReviewsUserSetting;
    return !userSettings.loading && dismissedYearInReview === I18n.moment().year() - 1;
  }, [userSettings]);
  const hasYearRollupLimit = useMemo(() => {
    var _rollupLimitData$data;
    // Ensure portal has rollup limit for an entire year.
    const rollupLimit = !rollupLimitData.loading && ((_rollupLimitData$data = rollupLimitData.data) === null || _rollupLimitData$data === void 0 ? void 0 : _rollupLimitData$data.portalRollUpLimit.maximumRequestDurationMillis) || 0;
    return rollupLimit >= MILLISECONDS_IN_A_YEAR;
  }, [rollupLimitData]);
  const isPortalOldEnoughForExport = useMemo(() => {
    var _userInfo$portal;
    const portalCreatedAt = userInfo === null || userInfo === void 0 || (_userInfo$portal = userInfo.portal) === null || _userInfo$portal === void 0 ? void 0 : _userInfo$portal.created_at;
    // @ts-expect-error 'portalTz' does not exist on type 'Moment'
    return portalCreatedAt < I18n.moment().portalTz().startOf('year').valueOf();
  }, [userInfo]);
  const isJanuary = useMemo(() => {
    // Ensure it is the start of the year (January)
    return I18n.moment().month() === 0;
  }, []);
  return !hasDismissedYearInReview && hasYearRollupLimit && isJanuary && isPortalOldEnoughForExport;
}